'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

//import 'babel/polyfill';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _historyLibCreateBrowserHistory = require('history/lib/createBrowserHistory');

var _historyLibCreateBrowserHistory2 = _interopRequireDefault(_historyLibCreateBrowserHistory);

var _scrollBehaviorLibUseStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _scrollBehaviorLibUseStandardScroll2 = _interopRequireDefault(_scrollBehaviorLibUseStandardScroll);

var _reduxCreate = require('./redux/create');

var _reduxCreate2 = _interopRequireDefault(_reduxCreate);

var _helpersApiClient = require('./helpers/ApiClient');

var _helpersApiClient2 = _interopRequireDefault(_helpersApiClient);

var _socketIoClient = require('socket.io-client');

var _socketIoClient2 = _interopRequireDefault(_socketIoClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactisAcl = require('reactis-acl');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _helpersMakeRouteHooksSafe = require('./helpers/makeRouteHooksSafe');

var _helpersMakeRouteHooksSafe2 = _interopRequireDefault(_helpersMakeRouteHooksSafe);

require('babel/register');

var acl = new _reactisAcl.Acl(window._acl);
var user = new _reactisAcl.User(acl, window._initState.auth ? window._initState.auth.roles : []);

var client = new _helpersApiClient2['default']();
var keepAlive = function keepAlive() {
	client.call('system.keepalive');
	setTimeout(keepAlive, 60000);
};
setTimeout(keepAlive, 60000);

// Three different types of scroll behavior available.
// Documented here: https://github.com/rackt/scroll-behavior
var history = _scrollBehaviorLibUseStandardScroll2['default'](_historyLibCreateBrowserHistory2['default'])();

var dest = document.getElementById('app');
var store = _reduxCreate2['default'](client, history, window._initState);

//syncReduxAndRouter(history, store);

var component = _react2['default'].createElement(
	_reactisAcl.UserProvider,
	{ user: user },
	_react2['default'].createElement(
		_reactRouter.Router,
		{ history: history },
		_routes2['default'](store)
	)
);

_reactDom2['default'].render(_react2['default'].createElement(
	_reactRedux.Provider,
	{ store: store, key: 'provider' },
	component
), dest);

if (process.env.NODE_ENV !== 'production') {
	window.React = _react2['default']; // enable debugger
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/client.js
 ** module id = 974
 ** module chunks = 2
 **/